import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { MaPort } from "../../../modules/Disbursment_modules/dis-repository/pages/create-port-tariff/port.model";
import { CommonHttpModule } from "../../providers/commonHttpModule";
import { MaPortService } from "src/app/modules/Disbursment_modules/dis-repository/pages/create-port-tariff/create-tariff.model";

@Injectable({
  providedIn: "root"
})
export class PortService {


  constructor(private http: CommonHttpModule) { }


  // method to get the data from db
  portDataFromDb(params: any): Observable<{ data: MaPort[]; total_count: number }> {
    return this.http.post<{ total_count: number; data: MaPort[] }>("portlist", params).pipe(
      map(response => ({
        total_count: response.total_count,
        data: response.data
      }))
    );
  }

  // method to send the data to db
  saveTariffRulesDataToDB(data: MaPort): Observable<any> {
    return this.http.post("tariff_rule/save", data).pipe(
      map((response) => {
        return response;
      })
    )
  }

  portsByCountry(countryId: number): Observable<MaPort[]> {
    return this.http.get<MaPort[]>(`ports/for-country/${countryId}`, null, undefined);
  }

  getPortsByCountryId(countryId: number): Observable<MaPort[]> {
    return this.http.get<any>(`ports/by-country/${countryId}`, {}).pipe(
      map(response => {
        // Check if response is an array or has a data property
        if (Array.isArray(response)) {
          return response;
        } else if (response && response.data && Array.isArray(response.data)) {
          return response.data;
        }
        return [];
      })
    );
  }

  // method to get the data from db
  getPortService(params: {}): Observable<MaPortService[]> {
    return this.http.post<{ port_services: MaPortService[] }>('getmaster-data', params).pipe(
      map(response => response.port_services ?? [])
    );
  }

  // Method to get master data for ports screen
  getMasterData(params: {}): Observable<any> {
    return this.http.post<any>(
      'getmaster-data',
      params
    ).pipe(
      map(response => response)
    );
  }

  // Method to get tariff rules
  getTariffRules(params: any): Observable<{
    status: string;
    total: number;
    page: number;
    page_size: number;
    data: any[];
  }> {
    const requestBody = {
      page: params.page || 0,
      page_size: params.page_size || 0,
      query_name: params.query_name || "",
      port_id: params.port_id || null
    };
    return this.http.post<any>(`tariff_rules`, requestBody).pipe(
      map(response => ({
        status: response.status,
        total: response.total,
        page: response.page,
        page_size: response.page_size,
        data: response.data || []
      })));
  }

  getFilterMasterData(params: {}): Observable<any> {
    return this.http.post<any>(
      'filter-getmaster-data',
      params
    ).pipe(
      map(response => response)
    );
  }
getAllPorts(): Observable<any> {
  return this.http.get<any>(
    'allports',
    { fields: ['port'] }
  ).pipe(
    map(response => response)
  );
}
}